import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@Component({
  selector: 'app-query-redirect',
  imports: [],
  templateUrl: './query-redirect.component.html',
})
@UntilDestroy()
export class QueryRedirectComponent implements OnInit {

  constructor(
    private readonly route: ActivatedRoute,
    private readonly router: Router
  ) {}

  ngOnInit() {
    this.route.queryParams.pipe(untilDestroyed(this)).subscribe(({q}) => {
      this.router.navigate(['insightful-chat'], {
        state: {
          chatQuery: q
        },
        queryParamsHandling: 'preserve'
      })
    });
  }

}
